// extracted by mini-css-extract-plugin
export default {"container":"ColorTextByValue_container__9TRyb"};